import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: 'auto',
    alignSelf: 'center',
    backgroundColor: theme.palette.bg.main,
    padding: theme.spacing(6, 2.5, 6, 3),
    display: 'flex',
    flexDirection: 'row',
    ['@media(max-width:1600px)']: {
      margin: theme.spacing(6, 'auto', 19.25, 'auto'),
    },
    ['@media(min-width:1600px)']: {
      margin: theme.spacing(6, 'auto', 16.25, 'auto'),
    },
  },
  offerGeneral: {
    width: 'calc(100% - 51.87%)',
    border: `1px solid ${theme.palette.cardBorder.main}`,
    borderRadius: '4px',
    boxShadow: `0px 8px 40px ${theme.palette.boxShadow.main}`,
  },
  offerGeneralRow: {
    padding: theme.spacing(3.375, 2.875, 2, 3),
    textAlign: 'left',
    borderRadius: '0px',
    borderBottom: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    boxShadow: 'none',
  },
  offerGeneralLabel: {
    fontSize: '14px',
    color: theme.palette.primary.light,
    marginBottom: theme.spacing(1),
  },
  offerGeneralValue: {
    fontSize: '14px',
    color: theme.palette.text.primary,
  },
  offerGeneralRowDivide: {
    borderRight: `1px solid ${theme.palette.detailedOfferBorder.main}`,
    padding: theme.spacing(2.125, 2.875, 2, 3),
    textAlign: 'left',
  },
  offerGeneralRowDivideContainer: {
    display: 'grid',
    gridTemplateColumns: '50% 50%',
    textAlign: 'left',
    borderBottom: `1px solid ${theme.palette.detailedOfferBorder.main}`,
  },
  generalRowPadding: {
    paddingTop: theme.spacing(2),
  },
  offerUrlContainer: {
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(2, 1.875, 2, 2.25),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  icon: {
    '&.MuiSvgIcon-root': {
      fontSize: '20px',
      width: '1em',
      height: '1em',
      flexShrink: 0,
      fill: 'currentColor',
      userSelect: 'none',
    },
    color: theme.palette.icon.main,
    paddingBottom: theme.spacing(0),
  },
  iconDisabled: {
    opacity: 0.3,
  },
  linkContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  iconButton: {
    '&.MuiIconButton-root': {
      padding: '0px',
    },
  },
  offerNameContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  viewMoreText: {
    fontSize: '12px',
    fontWeight: 500,
    color: theme.palette.select.light,
    cursor: 'pointer',
    width: '25%',
    textAlign: 'end',
  },
  linkRow: {
    borderBottom: '0px',
    paddingBottom: '24px',
  },
  offerNameAlign: {
    width: 'fit-content',
    textAlign: 'center',
  },
  copyLink: {
    marginLeft: theme.spacing(1.25),
    wordBreak: 'break-all',
  },
  noRightBorder: {
    borderRight: '0px',
  },
  cancelOfferRow: {
    padding: theme.spacing(0, 2.875, 2, 3),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'end',
    borderRadius: '0px',
    boxShadow: 'none',
  },
  cancelOfferText: {
    color: theme.palette.select.light,
    '&:hover': {
      backgroundColor: 'inherit',
      textDecoration: 'none',
    },
  },
  disabledButton: {
    cursor: 'default',
    '&.MuiTypography-root': {
      opacity: 0.5,
    },
  },
  cancelModalIcon: {
    color: theme.palette.warning.main,
    '&.MuiSvgIcon-root': {
      fontSize: '50px',
      padding: '0px',
    },
  },
  wrapperOfferName: {
    width: '75%',
  },
  offerNameValue: {
    wordBreak: 'break-all',
    textAlign: 'left',
  },
  divider: {
    width: '1px',
    backgroundColor: theme.palette.dividers.main,
    margin: theme.spacing(0, 2),
    flexShrink: 0,
  },
  statusMessage: {
    position: 'relative', 
    display: 'flex' 
  },
  status:{
      display: 'flex',
      alignItems: 'center',
  },
}))
